// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3375":"d94934b2","8921":"d94934b2"}[chunkId] + ".chunk.css";
};